const ABOUTVPP = 'about-vpp'
const EXPLOREUSECASES = 'explore-usecases'
const CREATEYOURFIRSTAPPCLIENT = 'create-your-first-app-client'
const HOWTOGENERATEACCESSTOKEN = 'how-to-generate-access-token'
const SAMPLEREQUESTANDRESPONSE = 'sample-request-and-response'

export {
  ABOUTVPP,
  EXPLOREUSECASES,
  CREATEYOURFIRSTAPPCLIENT,
  HOWTOGENERATEACCESSTOKEN,
  SAMPLEREQUESTANDRESPONSE
}